import script from "./WashingMarkPreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./WashingMarkPreview.vue?vue&type=script&lang=ts&setup=true"

import "./WashingMarkPreview.vue?vue&type=style&index=0&id=b494f5c8&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b494f5c8"]])

export default __exports__